module.exports = __webpack_public_path__ + "img/error-dark.f7daa99b.svg";